// extracted by mini-css-extract-plugin
export default {"loading-spacer":"styles_loading-spacer__ICMo+"};